import React, { useCallback, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Tab, Tabs } from "@material-ui/core";
import { AssetsStatistics } from "./AssetsStatistics";
import { SalesStatistics } from "./SalesStatistics";

const useStyles = makeStyles((theme) => ({
  tabArea: {
    marginBottom: theme.spacing(1),
  },
}));

export default React.memo(() => {
  const classes = useStyles();

  const [tabIndex, setTabIndex] = useState(0);

  const handleOnChangeTabs = useCallback((event: React.ChangeEvent<{}>, index: number) => setTabIndex(index), []);

  const panel = useMemo(() => {
    switch (tabIndex) {
      case 0:
        return <AssetsStatistics />;
      case 1:
        return <SalesStatistics />;
      default:
        return <></>;
    }
  }, [tabIndex]);

  return (
    <>
      <Paper className={classes.tabArea} square>
        <Tabs
          value={tabIndex}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleOnChangeTabs}
          aria-label="tabs"
        >
          <Tab label="資産" />
          <Tab label="売上" />
        </Tabs>
      </Paper>
      {panel}
    </>
  );
});
